import { SelectOption } from './types'
import { PrebuiltClasses } from './usePrebuiltClassesData'

export const prebuiltClassesToOption = () => (
  prebuiltClasses: PrebuiltClasses
): SelectOption => ({
  value: prebuiltClasses.id.toString(),
  label: prebuiltClasses.name,
})
